var _path, _path2, _path3, _g, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSharepoint({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1699_7424)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5313 19.6875C19.45 19.6875 23.4375 15.7 23.4375 10.7812C23.4375 5.86246 19.45 1.875 14.5312 1.875C9.61246 1.875 5.625 5.86246 5.625 10.7812C5.625 15.7 9.61246 19.6875 14.5313 19.6875Z",
    fill: "url(#paint0_linear_1699_7424)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 23.4375C26.6421 23.4375 30 20.0796 30 15.9375C30 11.7954 26.6421 8.4375 22.5 8.4375C18.3579 8.4375 15 11.7954 15 15.9375C15 20.0796 18.3579 23.4375 22.5 23.4375Z",
    fill: "url(#paint1_linear_1699_7424)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1699_7424",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 5,
    width: 13,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 22.0312C21.5625 25.3968 18.8343 28.125 15.4688 28.125C12.1032 28.125 9.375 25.3968 9.375 22.0312C9.375 18.6658 9.375 5.625 9.375 5.625L21.5625 5.625C21.5625 5.625 21.5625 19.8739 21.5625 22.0312Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1699_7424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4688 28.125C18.8342 28.125 21.5625 25.3967 21.5625 22.0312C21.5625 18.6658 18.8342 15.9375 15.4688 15.9375C12.1033 15.9375 9.375 18.6658 9.375 22.0312C9.375 25.3967 12.1033 28.125 15.4688 28.125Z",
    fill: "url(#paint2_linear_1699_7424)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 11.25C6.5625 9.69666 7.8217 8.4375 9.375 8.4375L15.9375 8.4375C17.4908 8.4375 18.75 9.69666 18.75 11.25L18.75 22.5C18.75 24.0533 17.4908 25.3125 15.9375 25.3125L6.5625 25.3125L6.5625 11.25Z",
    fill: "black",
    fillOpacity: 0.3
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.5625L1.875 6.5625C0.839466 6.5625 3.97169e-10 7.40197 8.87102e-10 8.4375L7.09681e-09 21.5625C7.58675e-09 22.598 0.839466 23.4375 1.875 23.4375L15 23.4375C16.0355 23.4375 16.875 22.598 16.875 21.5625L16.875 8.4375C16.875 7.40197 16.0355 6.5625 15 6.5625Z",
    fill: "url(#paint3_linear_1699_7424)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 16.9902C12.1875 15.5368 11.2127 14.8953 9.18436 14.1489C7.59631 13.5597 7.21895 13.3895 7.21895 12.8265C7.21895 12.342 7.69064 12.0146 8.49253 12.0146C9.31014 12.0146 10.0806 12.2896 10.9454 12.761L11.8259 11.2028C10.8982 10.6268 9.79753 10.3125 8.46109 10.3125C6.41706 10.3125 4.9548 11.36 4.9548 12.9574C4.9548 14.5941 6.11832 15.1178 8.068 15.8118C9.62456 16.3617 9.92334 16.6367 9.92334 17.1212C9.92334 17.6973 9.37303 17.9854 8.50825 17.9854C7.48624 17.9854 6.59002 17.6318 5.69379 17.0557L4.6875 18.5483C5.78813 19.3078 7.15605 19.6875 8.55543 19.6875C10.6624 19.6875 12.1875 18.6923 12.1875 16.9902Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1699_7424",
    x1: 5.625,
    y1: 10.7812,
    x2: 24.9218,
    y2: 10.7812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#103A3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#116B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1699_7424",
    x1: 16.875,
    y1: 12.1875,
    x2: 30,
    y2: 19.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D9097"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29BBC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1699_7424",
    x1: 11.25,
    y1: 20.1562,
    x2: 21.5625,
    y2: 24.8437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#31D6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1699_7424",
    x1: 3.99196e-9,
    y1: 15,
    x2: 18.2812,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#105557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#116B6E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1699_7424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSharepoint);
export default __webpack_public_path__ + "static/media/icon_sharepoint.c6f45d14a8a6fe2acf30ad8860bc4794.svg";
export { ForwardRef as ReactComponent };